import { FileSearch } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { CofaDocumentsPage } from './pages/CofaDocumentsPage'

/**
 * CofA — repository / reference library (sales, warehouse, ops,
 * regulatory, admin, viewer — read-only for all).
 *
 * Sprint 04b repurpose (2026-04-20): previously the LibraryView at
 * `/cofa-docs` with admin affordances. Now the read-only **primary**
 * CofA surface at `/cofa` — sales + warehouse land here to find a
 * CofA and download it. Admin surfaces (upload, rename, replace,
 * remove, approve, reject, retry) live on the management page at
 * `/cofa-docs`, rendered by the `cofa-pipeline` module (the module
 * directory name is a legacy misnomer post-swap).
 *
 * Data + registry components are shared via
 * `@/shell/services/cofa-registry/`.
 */
export default defineModule({
  id: 'cofa-documents',
  name: 'CofAs',
  shortName: 'CofAs',
  icon: FileSearch,
  navSection: 'regulatory',
  navOrder: 10,
  urlNamespace: '/cofa',
  routes: [{ path: '/', element: CofaDocumentsPage, label: 'CofAs' }],
  permissions: ['admin', 'regulatory', 'operations', 'operations_logistics', 'purchasing', 'warehouse', 'viewer'],
  densityDefault: 'comfortable',
  filterRailDefault: 'expanded',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g c',

  commandPaletteEntries: [
    {
      label: 'Go to CofAs',
      keywords: ['cofa', 'library', 'pdf', 'certificate', 'lot', 'repository', 'reference'],
      path: '/',
      group: 'modules',
      shortcut: 'g c',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'lot',
      label: 'View CofA for this lot',
      buildPath: (lotId) => `/?lot=${lotId}`,
    },
    {
      entity: 'product',
      label: 'Filter CofA by product',
      buildPath: (productId) => `/?product=${productId}`,
    },
    {
      entity: 'vendor',
      label: 'Filter CofA by vendor',
      buildPath: (vendorId) => `/?vendor=${vendorId}`,
    },
  ],
})
